import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { AppConfig } from '@myrtls/api-interfaces';

export const getConfigAction = createAction('[Config] Get Config');

export const getConfigSuccessAction = createAction(
    '[Config] Get Config Success',
    props<{ config: AppConfig }>(),
);

export const getConfigFailureAction = createAction(
    '[Config] Get Config Failure',
    props<{ error: HttpErrorResponse }>(),
);
